import * as request from '@/utils/request'
const BASE_URL = 'paas'
export default {
  /**
   * @description 提交登录信息，进行登录， 手机登录
   * @author YM
   * @date 2019-02-12
   * @returns
   */
  submitLoginInfo(data) {
    return request.post(`${BASE_URL}/login/login`,data)
  },
  /**
   * @description 提交退出登录
   * @author YM
   * @date 2019-02-13
   * @returns
   */
  submitLogout() {
    return request.get(`${BASE_URL}/login/logout`)
  },

  /**
   * @description 发送验证码
   * smsSend
   * @author YM
   * @date 2019-02-13
   * @returns
   */
  smsSend(data) {
    return request.post(`${BASE_URL}/sms/send`,data)
  }, 
  
  /**
   * @description 验证验证码
   * smsVerify
   * @author YM
   * @date 2019-02-13
   * @returns
   */
  smsVerify(data) {
    return request.post(`${BASE_URL}/sms/verify`,data)
  },

  /**
   * @description 短信验证码登录
   * @author YM
   * @date 2019-02-13
   * @returns
   */
  submitCodeLogin(data) {
    return request.post(`${BASE_URL}/login/sms`,data)
  },

  /**
   * @description 刷新token
   * @author YM
   * @date 2019-02-13
   * @returns
   */
  refreshToken(data) {
    return request.get(`${BASE_URL}/user/refresh_token`,data)
  },

  /**
   * @description 获取登陆用户信息
   * @author YM
   * @date 2019-02-13
   * @returns
   */
  getUserDetail(data) {
    return request.get(`${BASE_URL}/user/user_detail`,data)
  },

  /**
   * @description
   * @author YM
   * 获取用户权限对应的菜单-登陆用户
   * @date 2019-02-13
   * @returns
   */
  getUserMenu(data) {
    return request.get(`${BASE_URL}/menu/user_menu`,data)
  }





//   /**
//    * @description 获取验证码
//    * @author YM
//    * @date 2019-02-13
//    * @returns
//    */
//   getCode(data) {
//     return request.post('/sms/send', data)
//   },
//   /**
//    * 短信验证码校验
//    * @param {*} data
//    */
//   verifyCode(data) {
//     return request.post('/sms/verify', data)
//   },

  
}